const Mobile = () => {
    return null;
};

export default Mobile;
